import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./scss/index.scss";
import { Checkbox } from "@components/atoms";
import * as React from "react";
import { useIntl } from "react-intl";
import { useAlert } from "react-alert";
import { Link } from "react-router-dom";
import { Button, Form, OverlayTheme, OverlayType, TextField } from "../..";
import { accountConfirmUrl, accountUrl, baseUrl } from "../../../app/routes";
import { maybe } from "../../../core/utils";
import accountCreated from "../../../images/account-created.svg";
import mailSend from "../../../images/mail-send.svg";
import { TypedAccountRegisterMutation } from "./queries";
import { commonMessages } from "../../../intl";

var showSuccessNotification = function showSuccessNotification(data, hide, alert, show, intl) {
  var successful = maybe(function () {
    return !data.accountRegister.errors.length;
  });

  if (successful) {
    if (show) {
      show(OverlayType.popupMessage, OverlayTheme.modal, {
        data: {
          content: React.createElement(React.Fragment, null, data.accountRegister.requiresConfirmation ? React.createElement(Link, {
            to: baseUrl
          }, React.createElement(Button, {
            onClick: hide,
            className: "red",
            type: "button"
          }, intl.formatMessage(_defineProperty({
            defaultMessage: "go to homepage",
            "id": "components.OverlayManager.Login.RegisterForm.788127442"
          }, "id", "components.OverlayManager.Login.RegisterForm.788127442")))) : React.createElement(React.Fragment, null, React.createElement(Link, {
            to: baseUrl
          }, React.createElement(Button, {
            onClick: hide,
            className: "red",
            type: "button"
          }, intl.formatMessage(_defineProperty({
            defaultMessage: "go to homepage",
            "id": "components.OverlayManager.Login.RegisterForm.788127442"
          }, "id", "components.OverlayManager.Login.RegisterForm.788127442")))), React.createElement(Link, {
            to: accountUrl
          }, React.createElement(Button, {
            className: "white",
            type: "button"
          }, intl.formatMessage(_defineProperty({
            defaultMessage: "go to your account",
            "id": "components.OverlayManager.Login.RegisterForm.3287250114"
          }, "id", "components.OverlayManager.Login.RegisterForm.3287250114")))))),
          image: data.accountRegister.requiresConfirmation ? mailSend : accountCreated,
          text: data.accountRegister.requiresConfirmation ? intl.formatMessage({
            defaultMessage: "A link to confirm your email address is knocking at your door! Just one step to your account!",
            "id": "components.OverlayManager.Login.RegisterForm.1080089135"
          }) : intl.formatMessage({
            defaultMessage: "That’s one small step for a mankind - one giant leap for doorkind. Your account has now been created.",
            "id": "components.OverlayManager.Login.RegisterForm.4243903293"
          }),
          title: data.accountRegister.requiresConfirmation ? intl.formatMessage(commonMessages.success) : intl.formatMessage(commonMessages.congratulations)
        }
      });
    }
  }
};

var RegisterForm = function RegisterForm(_ref) {
  var show = _ref.show,
      hide = _ref.hide;
  var intl = useIntl();
  var alert = useAlert();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isConditionChecked = _React$useState2[0],
      setConditionChecked = _React$useState2[1];

  return React.createElement(TypedAccountRegisterMutation, {
    onCompleted: function onCompleted(data) {
      showSuccessNotification(data, hide, alert, show, intl);
    }
  }, function (registerCustomer, _ref2) {
    var loading = _ref2.loading,
        data = _ref2.data;
    return React.createElement(Form, {
      errors: maybe(function () {
        return data.accountRegister.errors;
      }, []),
      onSubmit: function onSubmit(event, _ref3) {
        var email = _ref3.email,
            password = _ref3.password;
        event.preventDefault();
        var redirectUrl = "".concat(window.location.origin).concat(accountConfirmUrl);
        registerCustomer({
          variables: {
            email: email,
            password: password,
            redirectUrl: redirectUrl
          }
        });
      }
    }, React.createElement(TextField, {
      name: "email",
      autoComplete: "email",
      label: intl.formatMessage(commonMessages.shortEmail),
      type: "email",
      required: true
    }), React.createElement(TextField, {
      name: "password",
      autoComplete: "password",
      label: intl.formatMessage(commonMessages.password),
      type: "password",
      required: true
    }), React.createElement("div", {
      className: "login__checkbox"
    }, React.createElement(Checkbox, {
      name: "conditions",
      checked: isConditionChecked,
      onChange: function onChange() {
        setConditionChecked(!isConditionChecked);
      }
    }, intl.formatMessage(_defineProperty({
      defaultMessage: "I have read",
      "id": "components.OverlayManager.Login.RegisterForm.274917402"
    }, "id", "components.OverlayManager.Login.RegisterForm.274917402"))), React.createElement("span", {
      className: "login__checkbox__text"
    }, intl.formatMessage(_defineProperty({
      defaultMessage: "Terms and Conditions",
      "id": "components.OverlayManager.Login.RegisterForm.963093209"
    }, "id", "components.OverlayManager.Login.RegisterForm.963093209")))), React.createElement("div", {
      className: "login__content__button"
    }, React.createElement(Button, _extends({
      className: "red",
      type: "submit",
      disabled: !isConditionChecked
    }, loading && {
      disabled: true
    }), loading ? intl.formatMessage(commonMessages.loading) : intl.formatMessage(commonMessages.register))));
  });
};

export default RegisterForm;